import { ref } from 'vue'
import { v4 } from 'uuid'

const messages = ref([])

function showMessage(text, status = 'info') {
  let color = 'bg-blue-100 text-blue-600'

  switch (status) {
    case 'warning':
      color = 'bg-yellow-100 text-yellow-600'
      break
    case 'error':
      color = 'bg-red-100 text-red-600'
      break
  }

  messages.value.push({ key: v4(), text, color, time: 5000 })
}

export { messages, showMessage }
